import React from 'react';
import Isvg from 'react-inlinesvg';
import _ from 'lodash';
import { parseAmount, friendlyDate } from 'app/utils/parsers';
import history from 'app/routes/history';

import Button from 'app/components/general/Button';
import { Form } from 'reactstrap';
import PaymentCard from 'app/components/matches/PaymentCard';
import SectionGroup from 'app/components/general/SectionGroup';
import SuccessIcon from 'app/images/icons/success.svg';
import { ICartLineItem } from 'app/ducks/carts/types';

interface ICartBasicComponentProps {
  matchCardData: {
    round: string;
    dateTime: string;
    eventInfo: string;
    amount: string;
    section: string;
    time: string;
    location: string;
    status: string;
    otherTeamStatus: string;
    statuses: [
      {
        colour: string;
        text: string;
      }
    ];
  };
  groupName: string;
  forfeitId: string;
  totalAmount: number;
  lineItems: ICartLineItem[];
}

export default class CartBasicComponent extends React.Component<
  ICartBasicComponentProps,
  {}
> {
  static defaultProps: ICartBasicComponentProps = {
    matchCardData: {
      round: undefined,
      dateTime: undefined,
      eventInfo: undefined,
      amount: undefined,
      section: undefined,
      time: undefined,
      location: undefined,
      statuses: undefined,
      status: undefined,
      otherTeamStatus: undefined,
    },
    groupName: undefined,
    forfeitId: undefined,
    totalAmount: undefined,
    lineItems: [],
  };

  continueToPayment = () => {
    history.push(`/payment/forfeit/${this.props.forfeitId}/pay`);
  };

  renderLineItems = () => _.map(this.props.lineItems, (lineItem) => (
    <div key={lineItem.description}>
      <div className="row">
        <div className="col col-8 text-dark-grey d-flex">
          <div>
            <div className="number-label">{lineItem.quantity}</div>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            {lineItem.description}
          </div>
        </div>
        <div className="col col-4 d-flex justify-content-end text-right text-dark-grey align-items-center">
          {parseAmount(lineItem.amount)}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="divider full" />
        </div>
      </div>
    </div>
  ));

  render(): React.ReactNode {
    return (
      <div>
        <Form onSubmit={this.continueToPayment}>
        {!_.isEmpty(this.props.matchCardData) && (
          <div className="row">
            <div className="col">
              <PaymentCard {...this.props.matchCardData} truncated />
            </div>
          </div>
        )}
        <div className="row with-margin-top-extra">
          <div className="col">
            <SectionGroup title="Payment Summary">
                <div className="row with-margin-top-10">
                  <div className="col text-dark-grey">
                    <span className="text-weight-medium-bold">Team: </span>
                    {this.props.groupName}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                {this.renderLineItems()}
                <div className="row">
                  <div className="col text-black text-weight-medium-bold">
                    Total Amount
                  </div>
                  <div className="col text-right text-dark-grey text-weight-medium-bold">
                    {parseAmount(this.props.totalAmount)}
                  </div>
                </div>
            </SectionGroup>
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col text-right">
            <Button
              className="btn-success"
              type="submit"
            >
              Continue to Pay
            </Button>
          </div>
        </div>
        </Form>
      </div>
    );
  }
}
